import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

// Auth
import { AuthContext } from '../../../utilities/auth-context';

// MUI Components
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const UserModal = ({ user, setUser, clearUser, onDelete }) => {

    const { state } = useContext(AuthContext);

    const [ open, setOpen ]         = useState(false);
    const [ title, setTitle ]       = useState('Add User');

    const isNew = user.id == 'new';
    const isSelf = !isNew && state.user === user.id;

    const saveUser = () => {
        axios.post('/user/save', user).then(response => {
            if( response.data.success ){
                toast.success('User saved successfully');
                clearUser();
            }
            else{
                toast.error(response.data.message);
            }
        }).catch(error => {
            const message = error.response?.data?.message || 'Failed to save user';
            toast.error(message);
        });
    }

    useEffect(() => {
        if( user.id ){
            setOpen(true);
            setTitle( isNew ? 'Add User' : 'Edit User');
        }
        else{
            setOpen(false);
        }
    }, [user.id]);

    return (
        <Dialog open={open} onClose={clearUser} maxWidth='sm' fullWidth className='user-modal'>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Box className='form'>
                    <TextField
                        label='Name'
                        value={user.name}
                        onChange={(e) => setUser({ ...user, name: e.target.value })}
                        fullWidth
                    />
                    <br/>
                    <TextField
                        label='Email'
                        type='email'
                        value={user.email}
                        onChange={(e) => setUser({ ...user, email: e.target.value })}
                        fullWidth
                    />
                    <br/>
                    <TextField
                        label='Password'
                        type='password'
                        value={user.password || ''}
                        onChange={(e) => setUser({ ...user, password: e.target.value })}
                        helperText={isNew ? 'Required' : 'Leave blank to keep the current password'}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                {!isNew && !isSelf && (
                    <Button variant='contained' color='error' onClick={onDelete} sx={{ mr: 'auto' }}>
                        Delete
                    </Button>
                )}
                <Button variant='contained' color='error' onClick={clearUser}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={saveUser}>Save</Button>
            </DialogActions>
        </Dialog>
    );

}

export default UserModal;
